import script from "./DimensionsEntry.vue?vue&type=script&setup=true&lang=js"
export * from "./DimensionsEntry.vue?vue&type=script&setup=true&lang=js"

import "./DimensionsEntry.vue?vue&type=style&index=0&id=f23a220e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f23a220e"]])

export default __exports__